var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var AlertTriangle = function AlertTriangle(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.466 2.384a3 3 0 0 1 4.144 1.122l7.095 12.242c.024.041.044.083.062.127A3 3 0 0 1 19.007 20H5c-.018 0-.037 0-.055-.002a1.005 1.005 0 0 1-.107 0 3 3 0 0 1-2.625-4.124c.018-.043.038-.085.062-.126L9.37 3.506a3 3 0 0 1 1.096-1.122ZM13 9a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0V9Zm0 6a1 1 0 1 0-2 0v.01a1 1 0 1 0 2 0V15Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default AlertTriangle;